import React, {useEffect,useState} from 'react';

export default function InstallApp(){
  const [prompt,setPrompt]=useState(null),[installed,setInstalled]=useState(false),[busy,setBusy]=useState(false);
  useEffect(()=>{
    const display=window.matchMedia('(display-mode: standalone)');
    const sync=()=>setInstalled(display.matches || navigator.standalone===true);
    const ready=e=>{e.preventDefault();setPrompt(e);};
    const complete=()=>{setInstalled(true);setPrompt(null);};
    sync();display.addEventListener?.('change',sync);
    window.addEventListener('beforeinstallprompt',ready);window.addEventListener('appinstalled',complete);
    return ()=>{display.removeEventListener?.('change',sync);window.removeEventListener('beforeinstallprompt',ready);window.removeEventListener('appinstalled',complete);};
  },[]);
  const install=async()=>{
    if(!prompt || busy)return;
    setBusy(true);
    try{await prompt.prompt();await prompt.userChoice;}finally{setPrompt(null);setBusy(false);}
  };
  if(installed)return null;
  return <details className="install-app-help" style={{margin:'8px 14px',padding:'10px',border:'1px solid #ffffff40',borderRadius:10,color:'#fff',fontSize:12}}>
    <summary style={{cursor:'pointer'}}>📲 Instalar Abogados Quiroz</summary>
    {prompt&&<button type="button" disabled={busy} onClick={()=>install().catch(()=>{})}>{busy?'Abriendo…':'Instalar aplicación'}</button>}
    <p>iPhone / iPad: abra el CRM en Safari → Compartir → Añadir a pantalla de inicio. Active «Abrir como app web» si aparece y pulse Añadir.</p>
    <p>Android: menú del navegador → Instalar aplicación o Añadir a pantalla de inicio.</p>
    <small>Requiere conexión a internet. Sus permisos y datos siguen siendo los del CRM.</small>
  </details>;
}
